module.exports = __webpack_public_path__ + "images/help/video-preview-invite-039054ff7e665b89fc8000e632bebfd2.jpg";